var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C10.663 13 11.2989 12.7366 11.7678 12.2678C12.2366 11.7989 12.5 11.163 12.5 10.5C12.5 9.83696 12.2366 9.20107 11.7678 8.73223C11.2989 8.26339 10.663 8 10 8C9.33696 8 8.70107 8.26339 8.23223 8.73223C7.76339 9.20107 7.5 9.83696 7.5 10.5C7.5 11.163 7.76339 11.7989 8.23223 12.2678C8.70107 12.7366 9.33696 13 10 13Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 11.2334V9.76669C1.6665 8.90003 2.37484 8.18336 3.24984 8.18336C4.75817 8.18336 5.37484 7.1167 4.6165 5.80836C4.18317 5.05836 4.4415 4.08336 5.19984 3.65003L6.6415 2.82503C7.29984 2.43336 8.14984 2.6667 8.5415 3.32503L8.63317 3.48336C9.38317 4.7917 10.6165 4.7917 11.3748 3.48336L11.4665 3.32503C11.8582 2.6667 12.7082 2.43336 13.3665 2.82503L14.8082 3.65003C15.5665 4.08336 15.8248 5.05836 15.3915 5.80836C14.6332 7.1167 15.2498 8.18336 16.7582 8.18336C17.6248 8.18336 18.3415 8.89169 18.3415 9.76669V11.2334C18.3415 12.1 17.6332 12.8167 16.7582 12.8167C15.2498 12.8167 14.6332 13.8834 15.3915 15.1917C15.8248 15.95 15.5665 16.9167 14.8082 17.35L13.3665 18.175C12.7082 18.5667 11.8582 18.3334 11.4665 17.675L11.3748 17.5167C10.6248 16.2084 9.3915 16.2084 8.63317 17.5167L8.5415 17.675C8.14984 18.3334 7.29984 18.5667 6.6415 18.175L5.19984 17.35C4.83659 17.1409 4.57115 16.7961 4.46179 16.3915C4.35243 15.9869 4.40807 15.5554 4.6165 15.1917C5.37484 13.8834 4.75817 12.8167 3.24984 12.8167C2.37484 12.8167 1.6665 12.1 1.6665 11.2334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting2);
export default __webpack_public_path__ + "static/media/setting2.c1104bad3b1fdef6c290c19c88101a12.svg";
export { ForwardRef as ReactComponent };